export { default } from './date-picker-localized'
